import { Coins, GItemName, Quantity } from "../flavours";
import {
  dementia as d,
  dreadlo as dr,
  godshard as go,
  gold as g,
  lustre as l,
  platinum as p,
  silver as s,
  starfire,
  tydal as t,
  voidC as v,
} from "./tools";
import { GShop, GShopEntry } from "./types";

const shop = (name: string, ...stock: GShopEntry[]): GShop => ({ name, stock });
const e = (item: GItemName, cost: Coins, stock: Quantity = 1): GShopEntry => ({
  item,
  cost,
  stock,
});

const shops = [
  shop(
    "Blunder Hills",
    e("Nomwich", 8n, 750),
    e("Hot Dog", 28n, 750),
    e("Cheezy Pizza", 80n, 750),
    e("Cue Tape", 12n, 5000),
    e("Small Mana Potion", 20n, 500),
    e("Small Strength Potion", 20n, 400),
    e("Small Life Potion", 16n, 400),
    e("Small Speed Potion", 28n, 400),
    e("Crude Oil", 32n, 1000),
    e("Weapon Upgrade Stone I", 500n, 12),
    e("Armor Upgrade Stone I", 400n, 24),
    e("Tool Upgrade Stone I", 440n, 16),
    e("Pugilist Demise", 16000n, 1),
    e("Power Statue", 40n, 3),
    e("Sculpting Tools", 3200n, 4),
    e("Target Stamp", 1000n, 1),
    e("Shield Stamp", 3200n, 1),
    e("Mana Stamp", 10000n, 1),
    e("Bummo Bag", 96n, 1),
    e("Storage Chest 2", 4000n, 1),
    e("Storage Chest 6", 10000n, 1),
    e("Storage Chest 7", 22000n, 1),
    e("Basketball", 400n, 1),
    e("Bottled Town Teleport", 200n, 50),
    e("Talent Point Reset Fragment", 800n, 1),
  ),

  shop(
    "Encroaching Forest Villas",
    e("Hot Dog", 28n, 1000),
    e("Cheezy Pizza", 80n, 1000),
    e("Cranberry Jam", 128n, 1000),
    e("Average Strength Potion", 100n, 500),
    e("Small EXP Potion", 100n, 500),
    e("Armor Upgrade Stone II", 3400n, 6),
    e("Vitality Stamp", 32000n, 1),
    e("Tarantulight", 26000n, 1),
    e("Silver Antique", 80000n, 1),
    e("Capitalist Case", 9996n, 2),
    e("Storage Chest 8", 22000n, 1),
    e("Storage Chest 12", 28000n, 1),
    e("Bottled Town Teleport", 200n, 30),
    e("Talent Point Reset Fragment", 800n, 1),
  ),

  shop(
    "YumYum Grotto",
    e("Kebab Sticks", 192n, 25000),
    e("Meat Pie", 320n, 25000),
    e("Saucy Weiner", 480n, 25000),
    e("Golden Dubloon", 14000n, 10000),
    e("BobJoePickle", 160000n, 1),
    e("Weapon Upgrade Stone II", 6000n, 12),
    e("Armor Upgrade Stone II", 3400n, 24),
    e("Tool Upgrade Stone II", 5000n, 16),
    e("Average Strength Potion", 100n, 20000),
    e("Average Speed Potion", 240n, 20000),
    e("Average Life Potion", 120n, 20000),
    e("Wealthy Wallet", 999996n, 1),
    e("Storage Chest 9", 35600n, 1),
    e("Storage Chest 10", 100000n, 1),
    e("Storage Chest 13", 240000n, 1),
    e("Storage Chest 15", 400000n, 1),
    e("Guilding Tools", 50000n, 1),
    e("Vendor Stamp", 400000n, 1),
    e("Bottled Town Teleport", 200n, 40),
    e("Talent Point Reset Fragment", 800n, 2),
    e("Secret Map", 40000n, 1),
  ),

  shop(
    "Faraway Piers",
    e("Copper Twine", 14000n, 1),
    e("Wormie Weight", 20000n, 1),
    e("Leafy Vines", 30000n, 1),
    e("One Pound of Steel", 40000n, 1),
    e("Dynamite", 70000n, 1),
    e("Needledrop", 60000n, 1),
    e("Not Dynamite", 220000n, 1),
    e("Tool Upgrade Stone I", 440n, 2),
    e("Tool Upgrade Stone II", 5000n, 1),
    e("Matty Bag Stamp", 26800n, 1),
    e("Clover Stamp", 48000n, 1),
    e("Cattleprod Token", 620000n, 1),
    e("Talent Point Reset Fragment", 800n, 1),
  ),

  shop(
    "Frostbite Towndra",
    e("Mountain Bread", s(5, 60), 25000),
    e("Yeti Ham", s(7, 60), 25000),
    e("Sheepie Dairy", s(12, 40), 25000),
    e("Cardboard Traps", g(2), 99),
    e("Wax Skull", g(2), 99),
    e("Weapon Upgrade Stone III", g(10), 12),
    e("Armor Upgrade Stone III", g(6), 30),
    e("Tool Upgrade Stone III", g(8), 21),
    e("Decent Strength Potion", s(6), 20000),
    e("Decent Speed Potion", s(16), 20000),
    e("Decent Life Potion", s(8), 20000),
    e("Prosperous Pouch", p(99, 99, 99, 96)),
    e("Storage Chest 16", g(60)),
    e("Storage Chest 17", g(80)),
    e("Storage Chest 18", p(1, 40)),
    e("Storage Chest 19", p(2)),
    e("Storage Chest 20", p(3, 20)),
    e("Storage Chest 21", p(5)),
    e("Bottled Town Teleport", s(2), 60),
    e("Talent Point Reset Fragment", s(8), 3),
    e("Damaged Cog", d(20)),
    e("Bottled World Town Teleport", p(4)),
    e("Anvil Reset Whetstone", p(1, 20)),
  ),

  shop(
    "Outer World Town",
    e("Pile of Processor Chips", p(2, 50)),
    e("Strung Jewels", p(10)),
    e("Cupcake", s(60), 5000000),
    e("Spicy Space Ribs", g(1, 60), 5000000),
    e("Sappy DNA Splicer", p(24), 10),
    e("Weapon Upgrade Stone IV", p(2, 40), 12),
    e("Armor Upgrade Stone IV", p(1, 80), 30),
    e("Tool Upgrade Stone IV", p(2, 20), 21),
    e("Potent Strength Potion", g(1, 8), 300000),
    e("Potent Speed Potion", g(3, 20), 300000),
    e("Potent Life Potion", g(1, 60), 300000),
    e("Potent EXP Potion", g(12), 300000),
    e("Sack of Success", d(99, 99, 99, 99, 96)),
    e("Egg Stamp", p(40)),
    e("Spice Stamp", d(2)),
    e("Sigil Stamp", d(28)),
    e("Blue Tome Pages", v(40)),
  ),

  shop(
    "Magma Rivertown",
    e("Lemon Slice", g(3, 20), 7500000),
    e("Grilled Cheese Nomwich", g(6, 40), 7500000),
    e("Magma Barrel", p(12), 200000),
    e("Weapon Upgrade Stone V", p(24), 12),
    e("Armor Upgrade Stone V", p(12), 30),
    e("Tool Upgrade Stone V", p(16), 21),
    e("Refinery Stamp", d(1, 20)),
    e("Red Tome Pages", starfire(40)),
  ),

  shop(
    "Spirit Village",
    e("BoneJoePickle", l(16)),
    e("Crop Transfer Ticket", starfire(4)),
    e("Raw Nigiri", g(28), 7500000),
    e("Dumpling", p(2), 7500000),
    e("Plasma Barrel", d(80), 200000),
    e("Weapon Upgrade Stone VI", d(24), 12),
    e("Armor Upgrade Stone VI", d(1, 80), 30),
    e("Tool Upgrade Stone VI", d(1, 20), 21),
    e("Forge Stamp", l(4)),
    e("Storage Chest 26", dr(40)),
    e("Storage Chest 27", go(10)),
    e("Storage Chest 28", t(2, 80)),
  ),
];
export default shops;
